export default "__VITE_ASSET__BK$ix3Vp__"